import { EventDispatcher } from 'three';
import { singleton } from 'tsyringe';
import AxiosHttpClient from '../../Network/AxiosHttpClient';
import { SendMessageRequest, SendMessageResponse } from './types/assistants';
import envierments from '../../../Environments/envierments';

@singleton()
export default class OpenAiClient extends EventDispatcher {
    private conversationId: string | null = null;
    private collectionId: number | null = envierments.openAi.collectionId;

    public constructor(public httpClient?: AxiosHttpClient) {
        super();
    }

    public setCollectionId(id: number | null) {
        this.collectionId = id;
    }

    private authHeaders() {
        return { Authorization: `JWT ${localStorage.getItem('token')}` };
    }

    public async init() {
        const response = await this.httpClient.instance.post(
            `api/v2/openai/responses/conversation?collection_id=${this.collectionId}`,
            null,
            { headers: this.authHeaders() },
        );
        this.conversationId = response.data.id;
    }

    public async transcriptAudio(audioBase64: string) {
        const cleanBase64 = audioBase64.replace(/^data:audio\/(wav|webm|ogg|mp3);base64,/, '');

        return await this.httpClient.instance.post(
            'api/v2/openai/audio/transcriptions',
            {
                file: cleanBase64,
                model: 'whisper-1',
                language: 'pl',
                collection_id: this.collectionId,
            },
            { headers: this.authHeaders() },
        );
    }

    public async textToSpeech(text: string) {
        return await this.httpClient.instance.post(
            'api/v2/openai/audio/speech',
            {
                text,
                model: 'tts-1',
                voice: 'alloy',
                response_format: 'mp3',
                speed: 1.0,
                collection_id: this.collectionId,
            },
            { responseType: 'arraybuffer', headers: this.authHeaders() },
        );
    }

    public async sendMessage(request: SendMessageRequest): Promise<SendMessageResponse> {
        const response = await this.httpClient.instance.post<SendMessageResponse>(
            `api/v2/openai/responses/send_message?collection_id=${this.collectionId}`,
            {
                model: envierments.openAi.model,
                instructions: envierments.openAi.instructions,
                conversation_id: this.conversationId,
                ...request,
            },
            { headers: this.authHeaders() },
        );
        return response.data;
    }

    public async sendAudioMessage(audioBase64: string) {
        // console.log('[chatbot-debug] audioBase64 length:', audioBase64?.length);
        const transcribedText = await this.transcriptAudio(audioBase64);
        // console.log('[chatbot-debug] transcription raw data:', transcribedText.data);
        const text =
            typeof transcribedText.data === 'string' ? transcribedText.data : transcribedText.data.transcription;
        // console.log('[chatbot-debug] transcription text sent to model:', JSON.stringify(text));
        return await this.sendMessage({ text });
    }
}
